import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("c2c_cookie_consent")) setShow(true);
  }, []);
  if (!show) return null;
  const accept = () => { localStorage.setItem("c2c_cookie_consent", "1"); setShow(false); };
  return (
    <div className="fixed bottom-0 sm:bottom-4 inset-x-0 sm:inset-x-auto sm:right-4 z-[60] sm:max-w-sm mb-0 sm:mb-0" data-testid="cookie-banner">
      <div className="m-3 sm:m-0 rounded-xl border border-brand-line bg-white p-4 shadow-2xl">
        <p className="text-sm text-brand-muted">
          We use cookies to improve your experience and measure site performance. See our{" "}
          <Link to="/privacy" className="font-semibold text-brand-navy underline">Privacy Policy</Link>.
        </p>
        <div className="mt-3 flex gap-2">
          <button onClick={accept} className="rounded-full bg-brand-navy px-4 py-2 text-sm font-bold text-white hover:bg-brand-navy2 transition-colors" data-testid="cookie-accept">Accept</button>
          <button onClick={accept} className="rounded-full border border-brand-line px-4 py-2 text-sm font-semibold text-brand-navy hover:bg-brand-surface" data-testid="cookie-decline">Essential only</button>
        </div>
      </div>
    </div>
  );
}
